import { render, staticRenderFns } from "./UnverifiedClientList.vue?vue&type=template&id=a0d4cef8&"
import script from "./UnverifiedClientList.vue?vue&type=script&lang=ts&"
export * from "./UnverifiedClientList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports